import React, { useContext, useState } from 'react'
import BigModal from '../../../../components/Modals/BigModal'
import {
  Alert,
  AlertTitle,
  Button,
  ButtonGroup,
  Stack,
  Typography,
} from '@mui/material'
import PresetsTextField from '../../../../components/Forms/PresetsTextField'
import SmallModal from '../../../../components/Modals/SmallModal'
import API from '../../../../services/API'
import { GlobalContext } from '../../../../App'

const ConfirmRemoveStaff = ({
  open,
  onClose,
  existingShift,
  setAssignedTo,
  loadEvent,
}) => {
  const [removalReason, setRemovalReason] = useState('')
  const { setToast } = useContext(GlobalContext)

  const handleRemove = (e) => {
    e.preventDefault()
    // Portalled modals bubble events through the React tree, so without this
    // the submit would also fire an ancestor form's onSubmit (which is how
    // the shift editor once re-saved the stale assignee mid-removal)
    e.stopPropagation()
    API.post('/remove-staff-from-shift', {
      shiftID: existingShift._id,
      staffID: existingShift.assignedTo._id,
      reason: removalReason,
      changeTo: open?.employee?._id ? open.employee._id : null,
    }).then((res) => {
      if (res.status === 200) {
        setToast({ message: 'Staff removed from Shift' })
        setAssignedTo(open?._id ? open : null)
        onClose()
        loadEvent()
      } else {
        setToast({
          message:
            res.data?.error || 'Unable to Remove staff. Please try again later',
          severity: 'error',
        })
      }
    })
  }

  return (
    <BigModal autoWidth open={!!open} onClose={onClose}>
      <Stack gap={1} component="form" onSubmit={handleRemove}>
        <Typography variant="title2">
          Are you sure you want to remove{' '}
          {existingShift?.assignedTo?.userAccount?.firstName}{' '}
          {existingShift?.assignedTo?.userAccount?.lastName} from this shift?
        </Typography>
        <>This will send an email notification to the staff member.</>
        {existingShift?.overTime?.required && (
          <Alert
            severity={
              existingShift.overTime.status === 'Approved' ? 'error' : 'warning'
            }
          >
            <AlertTitle>
              {existingShift.overTime.status === 'Approved'
                ? 'Approved overtime claim'
                : existingShift.overTime.status === 'Rejected'
                  ? 'Rejected overtime claim'
                  : 'Pending overtime claim'}
            </AlertTitle>
            This shift has an overtime claim
            {existingShift.overTime.status === 'Approved'
              ? ' that has been approved for pay'
              : ''}
            . Removing {existingShift?.assignedTo?.userAccount?.firstName} from
            the shift will permanently delete the claim.
          </Alert>
        )}
        {(existingShift?.clock?.startedAt || existingShift?.clock?.endedAt) && (
          <Alert severity="warning">
            <AlertTitle>Clock record</AlertTitle>
            {existingShift?.assignedTo?.userAccount?.firstName} has clocked{' '}
            {existingShift?.clock?.endedAt ? 'in and out of' : 'in to'} this
            shift. Removing them will permanently delete their clock record.
          </Alert>
        )}
        <PresetsTextField
          value={removalReason}
          required
          setValue={setRemovalReason}
          label="Reason for Cancellation"
          presets={[
            'Event Cancelled',
            'Staff no longer available',
            'Shift Swapped',
            'Sickness',
          ]}
        />
        <ButtonGroup fullWidth>
          <Button variant="outlined" onClick={onClose} color="error">
            Go Back
          </Button>
          <Button variant="contained" type="submit" color="success">
            Remove from Shift
          </Button>
        </ButtonGroup>
      </Stack>
    </BigModal>
  )
}

export default ConfirmRemoveStaff
